import { render, staticRenderFns } from "./RegisterProviderType.vue?vue&type=template&id=e5a9faf8"
import script from "./RegisterProviderType.vue?vue&type=script&lang=js"
export * from "./RegisterProviderType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Providers/wizard/RegisterProviderType.vue
// module id = 887
// module chunks = 31